import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { Head } from '@inertiajs/vue3';
    import AppLayout from '@/layouts/AppLayout.vue';
    import PageCard from '@/components/PageCard.vue';
    import type { BreadcrumbItem } from '@/types';
    import PowerBI from '@/components/PowerBI.vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'Dashboard',
  setup(__props) {

    const breadcrumbs: BreadcrumbItem[] = [
        {
            title: 'menu.power_bi',
        },
        {
            title: 'menu.power_bi_dashboard',
            href: route('v2.powerbi.dashboard.index'),
        },
    ];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Head), {
      title: _ctx.$t('menu.power_bi')
    }, null, 8, ["title"]),
    _createVNode(AppLayout, { breadcrumbs: breadcrumbs }, {
      default: _withCtx(() => [
        _createVNode(PageCard, null, {
          default: _withCtx(() => [
            _createVNode(PowerBI)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})